import React, { Component } from 'react';

import Page from '../../../components/Page';

import policydoc from '../../../docs/sample-policy-document.pdf'

export default class PolicyDocument extends Component{
	
	render(){

		return(
			<Page isAdminPage={ true } pageTitle="Policy Document">
				<embed 
                    src={ policydoc } 
                    style={{ background: "#ddd", height: "80vh", width: "100%" }}></embed>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/pages/dashboard/policies/PolicyDocument.jsx